import * as React from "react";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";
import {SpinnerButton} from "shared/controls/SpinnerButton";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";
import {faSignInAlt} from "@fortawesome/free-solid-svg-icons/faSignInAlt";
import {WpAjaxPost} from "shared/core/ajax/WPAjaxPost";
import {StoreBase} from "shared/core/Store/StoreBase";
import {SwitchContainer} from "shared/core/animation/SwitchContainer";
import {RNTextArea} from "shared/controls/SingleInputs/RNTextArea/RNTextArea";
import {faPaperPlane} from "@fortawesome/free-solid-svg-icons/faPaperPlane";
import {ToastService} from "shared/core/services/ToastService";
import {faCheck} from "@fortawesome/free-solid-svg-icons/faCheck";
import {faCheckCircle} from "@fortawesome/free-regular-svg-icons/faCheckCircle";
require("regenerator-runtime/runtime");

export class Support extends React.Component<SupportProps, SupportState> {
    static defaultProps: Partial<SupportProps> = {};
    public LogInStore:LogInStore;
    public SupportStore:SupportStore;
    constructor(props: SupportProps) {
        super(props);
        this.LogInStore=new LogInStore().Merge();
        this.SupportStore=new SupportStore().Merge({Source:rnFormVar.Source});
        this.state = {
            LogInIsBusy:false,
            SubmitIsBusy:false,
            TicketSubmittedSuccessfully:false
        };
    }

    public render() {
        return(
            <SwitchContainer>
                {rnFormVar.IsLoggedIn? this.GetLoggedInContent(): this.GetNotLoggedInContent()}
            </SwitchContainer>
        )
    }

    private GetLoggedInContent() {
        if(!rnFormVar.LicenseIsValid)
        {
            return (
                <div>
                    Sorry the support period for your license expired, to keep getting support please <a href={rnFormVar.RenewLink}>go to your account and renew it</a>
                </div>
            )
        }


        return(
            <div>
                <RNTextInput Value={rnFormVar.UserName} disabled={true} Label={'User Name'}/>
                <RNTextInput Value={rnFormVar.UserEmail} disabled={true} Label={"Email"}/>
                <RNTextArea inputStyle={{width:'100%'}} style={{width:'100%'}} height={200} Label={'Message'} Store={this.SupportStore} PropertyName={"Message"}/>
                <div>
                    <SpinnerButton OnClick={()=>this.Submit()} IsBusy={this.state.SubmitIsBusy} Icon={<FontAwesomeIcon icon={faPaperPlane}/>}>Submit</SpinnerButton>
                    {this.state.TicketSubmittedSuccessfully &&
                        <span style={{
                            color: '#218838',
                            marginLeft: 5,
                            display: 'inline-flex',
                            alignItems: 'center'
                        }}><FontAwesomeIcon style={{marginRight: 3}}
                                            icon={faCheckCircle}/> Ticket submitted successfully</span>
                    }
                </div>
            </div>
        )
    }

    private GetNotLoggedInContent() {
        return (
            <div>
                <p style={{marginBottom:10}}><strong>You need to be logged in to create a support ticket</strong></p>
                <RNTextInput<LogInStore> Label={'User name'} Store={this.LogInStore} PropertyName={"UserName"}  />
                <RNTextInput<LogInStore> Label={'Password'} type={'password'} Store={this.LogInStore} PropertyName={"Password"} style={{marginBottom:0}} inputStyle={{marginBottom:0}}/>
                <div style={{marginBottom:10}}>
                    <a href={rnFormVar.ForgotYourPassword}>Forgot your password?</a>
                </div>
                <SpinnerButton IsBusy={this.state.LogInIsBusy} OnClick={()=>this.LogIn()} Icon={<FontAwesomeIcon icon={faSignInAlt}/>} >Log In</SpinnerButton>

                <p style={{marginTop:10}}>
                    If you have the free version and don't have an account please use the forum <a href={rnFormVar.FreeSupportLink}>here</a>


                </p>
            </div>


        )
    }

    private async LogIn() {
        this.setState({LogInIsBusy:true});
        let result=await WpAjaxPost.Post('LogIn',this.LogInStore.ToObject());
        this.setState({LogInIsBusy:false});
        if(result!=null)
        {
            rnFormVar.IsLoggedIn=true;
            rnFormVar.UserName=result.UserName;
            rnFormVar.UserEmail=result.UserEmail;
            rnFormVar.IsLoggedIn=true;
            rnFormVar.LicenseIsValid=result.LicenseIsValid;
            this.forceUpdate();
        }


    }

    private async Submit() {
        this.setState({TicketSubmittedSuccessfully:false});
        if(this.SupportStore.Message.trim()=='')
        {
            ToastService.SendErrorMessage('Message can not be empty');
            return;
        }
        this.setState({SubmitIsBusy:true});

        let result=await WpAjaxPost.Post('SubmitTicket',this.SupportStore.ToObject());
        this.setState({SubmitIsBusy:false});

        if(result!=null) {
            this.SupportStore.Message='';
            this.setState({SubmitIsBusy: false, TicketSubmittedSuccessfully: true});
        }
    }
}

class LogInStore extends StoreBase{
    public UserName:string;
    public Password:string;
    protected LoadDefaultValues() {
        this.UserName='';
        this.Password='';
    }

}

class SupportStore extends StoreBase{
    Message:string;
    Source:string;

    protected LoadDefaultValues() {
        this.Message='';
        this.Source='';
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface SupportProps {

}

interface SupportState {
    LogInIsBusy:boolean;
    SubmitIsBusy:boolean;
    TicketSubmittedSuccessfully:boolean;
}

//#endregion "My Region"